import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import cls from './CancelInvoice.module.scss';
import { useAppDispatch, useAppSelector } from '../../../hooks/defaultHooks';
import { modalExtra } from '../../../selectors/selectors';
import { useUpdateInvoiceStatusMutation } from '../../invoices/invoices.service';
import { isFetchBaseQueryError } from '../../../utils/helpers';
import { toast } from 'react-toastify';
import { closeModal } from '../../../store/slices/modalSlice';

const CancelInvoice = () => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const extra = useAppSelector(modalExtra);
  const dispatch = useAppDispatch();
  const [changeInvoiceStatus] = useUpdateInvoiceStatusMutation();
  const closeHandler = (): void => {
    dispatch(closeModal());
  };
  const cancelHandler = async () => {
    setDisabled(true);
    try {
      await changeInvoiceStatus({
        id: extra?.id as string,
        status: 'CANCELED',
      }).unwrap();
      if (extra?.handler !== undefined) extra.handler();
      dispatch(closeModal());
      toast.success('Invoice cancelled');
    } catch (error) {
      setDisabled(false);
      if (isFetchBaseQueryError(error)) {
        if (error.status === 400) {
          toast.error('Please try again later');
        }
      }
    } finally {
      setDisabled(false);
    }
  };
  return (
    <>
      <Modal.Header className={cls.ModalHeader} data-testid="modal-title" closeButton>
        <h3 className="title-3">Change to Cancelled status?</h3>
      </Modal.Header>
      <Modal.Body className={cls.ModalBody}>
        <p>Are you sure you want to change the invoice to Cancelled status?</p>
        <div className={cls.Buttons}>
          <Button
            type="button"
            className="w-100"
            variant="danger"
            disabled={disabled}
            onClick={cancelHandler}
          >
            Change Status
          </Button>
          <Button className="w-100" variant="outline-dark" onClick={closeHandler}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </>
  );
};

export default CancelInvoice;
